const SLIDERS_DESKTOP = 'desktop';
const SLIDERS_MOBILE = 'mobile';

export { SLIDERS_DESKTOP, SLIDERS_MOBILE };
